const ChevronLeft = ({clr, width, height}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18" width={width || 10} height={height || 18} fill="none">
    <path
      stroke={clr || "#CBCBCB"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 16.5 1.5 9 9 1.5"
    />
  </svg>
)

export default ChevronLeft